module.exports = __webpack_public_path__ + "img/10.dac61a38.jpg";